/**
 * Get avatar initials from username or email fallback
 * Uses first 1-2 characters of username, or first letter of email
 */
export function getAvatarInitials(username?: string | null, fallbackEmail?: string | null): string {
  if (username && username.trim()) {
    // Use first 1-2 characters of username
    return username.trim().slice(0, 2).toUpperCase();
  }
  
  if (fallbackEmail && fallbackEmail.trim()) {
    // Use first letter of email
    return fallbackEmail.trim().charAt(0).toUpperCase();
  }
  
  return 'U';
}
